/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Sign_InInputs */

const en_agent_authorization_sign_in = /** @type {(inputs: Agent_Authorization_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to Seek AI`)
};

const zh_agent_authorization_sign_in = /** @type {(inputs: Agent_Authorization_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录 Seek AI`)
};

/**
* | output |
* | --- |
* | "Sign in to Seek AI" |
*
* @param {Agent_Authorization_Sign_InInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_sign_in = /** @type {((inputs?: Agent_Authorization_Sign_InInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Sign_InInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_sign_in(inputs)
	return zh_agent_authorization_sign_in(inputs)
});
export { agent_authorization_sign_in as "agent.authorization.sign_in" }